<template>
    <span v-html="range"></span>
</template>

<script>
    import moment from 'moment';

    export default {
        name: "DateRange",
        props: ['start', 'end'],
        computed: {
            range: function() {
                if (this.start && this.end) {
                    let mStart = moment(this.start);
                    let mEnd = moment(this.end);
                    if (mStart.isSame(mEnd, 'day')) {
                        return mStart.format('dddd, MMMM Do YYYY') + ', <strong>' + mStart.format('h:mm a') + ' to ' + mEnd.format('h:mm a') + '</strong>';
                    } else {
                        return mStart.format('dddd, MMMM Do YYYY, h:mm a') + ' to ' + mEnd.format('MMMM Do YYYY, h:mm a')
                    }
                } else {
                    return '-';
                }
            }
        }
    }
</script>
